import React from 'react'

const AboutUs = () => {
  return (<>  <div className="p-5 text-center bg-light mw-100 mh-100 d-flex flex-column ">
  <h1 className="mb-3">AboutUs</h1>
  <h4 className="mb-3">We are News Tech company provide short news and also full article.</h4>
  
</div>  
 
    </>
  )
}

export default AboutUs;